module.exports = __webpack_public_path__ + "static/media/userGuide.5379efb2.pdf";